import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { unwrapElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';

export class SelectMultipleAdapter extends TestAdapter {
  /**
   * Change and commit the value of the component.
   * @param value {Set<string | number> | undefined} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: Set<string | number> | undefined) {
    const driver = this.getTestDriver();
    const el = await this.getElement();

    // Convert to an array to pass through webdriver. It does not take Set.
    const arrayValue = value ? [...value] : undefined;

    // For now, unwrap the TestElement to get the underlying DOM element until JET-73740 is fixed.
    await driver.executeScript(
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      (el: any, arrayValue: Array<string | number> | undefined) => {
        const val = arrayValue ? new Set(arrayValue) : undefined;
        el._changeValue(val);
      },
      unwrapElement(el),
      arrayValue
    );
  }

  /**
   * Clear the value of the component.
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }
}
